module.exports = __webpack_public_path__ + "static/media/steps-to-install-and-setup-jenkins-ec2-Instance.08d98a97.md";